export const SET_TEACH_TRAIN_STORE_INFO = 'SET_TEACH_TRAIN_STORE_INFO' // 存储选中门店信息
export const SET_EXPORT_PARAMS = 'SET_EXPORT_PARAMS' // 存储导出记录
